import { render, staticRenderFns } from "./SessionAboutEnd.template.vue?vue&type=template&id=616e1fd9&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e1fd9",
  null
  
)

export default component.exports